export default __webpack_public_path__ + "static/media/vuesax-linear-stickynote.b7b0ea87.svg";